export enum LanguageVersion {
  EN = 'en',
}
